import { useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import useCreateCoreProduct, {
  CreateCoreProductPayload,
} from "../../services/useCreateCoreProduct";
import CoreProductForm from "../../components/CoreProductForm";
import { useState } from "react";

/**
 * Página de criação do produto do catálogo (core.Product)
 */
const CoreProductCreate = () => {
  const navigate = useNavigate();
  const { mutate: createProduct, isLoading: isSubmitting } =
    useCreateCoreProduct();
  const [errorMessage, setErrorMessage] = useState<string>("");

  const handleSubmit = (values: CreateCoreProductPayload) => {
    setErrorMessage("");

    createProduct(
      { data: values },
      {
        onSuccess: (createdProduct) => {
          // Redirecionar para a página de detalhes do produto criado
          navigate(`/app/core-products/${createdProduct.id}`);
        },
        onError: (err: any) => {
          console.error("Erro ao criar core product", err);

          const data = err?.response?.data ?? err;
          if (data && typeof data === "object") {
            const errorMessages = Object.keys(data).map((key) => {
              const value = (data as any)[key];
              const messages = Array.isArray(value) ? value : [value];
              return `${key}: ${messages.join(", ")}`;
            });
            setErrorMessage(errorMessages.join("\n"));
          } else {
            setErrorMessage("Erro ao criar produto. Tente novamente.");
          }
        },
      },
    );
  };

  const handleCancel = () => {
    navigate("/app/core-products");
  };

  const handleCloseErrorMessage = () => {
    setErrorMessage("");
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box
        sx={{
          mb: 3,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h4" component="h1">
          Novo produto (novo catálogo)
        </Typography>
        <Button startIcon={<ArrowBackIcon />} onClick={handleCancel}>
          Cancelar
        </Button>
      </Box>

      <Card>
        <CardContent>
          <CoreProductForm
            isCreateMode={true}
            onSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            errorMessage={errorMessage}
            onCloseErrorMessage={handleCloseErrorMessage}
          />
        </CardContent>
      </Card>
    </Container>
  );
};

export default CoreProductCreate;
